import { normalizeDamageInsuranceBrief } from '@g/utils/damageInsurance'
import { isCvsCarrier } from '@g/order-shared/cvsDelivery'

const CONFIRMATION_KEYS = Object.freeze([
  'damageInsuranceRisk',
  'damageInsuranceBrief',
  'hzkPickup',
  'x3OverTen',
])

function assertConfirmationKey (state, key, field) {
  if (!CONFIRMATION_KEYS.includes(key) || !Object.prototype.hasOwnProperty.call(state.createView[field], key)) {
    throw new Error(`未知下单确认项：${key}`)
  }
}

export const mutations = {
  setDeliveryMode (state, deliveryMode) {
    state.createView.deliveryMode = deliveryMode
  },
  resetUnavailableCvsDelivery (state) {
    state.createView.deliveryMode = '0'
    if (isCvsCarrier(state.createForm?.jyoCarrier)) {
      state.createForm.jyoCarrier = ''
    }
  },
  setPendingTransport (state, pendingTransport) {
    state.createView.pendingTransport = pendingTransport
  },
  setEstimateWeight (state, estimateWeight) {
    state.createView.estimateWeight = estimateWeight
  },
  setUseFinalDiscountRate (state, useFinalDiscountRate) {
    state.createView.useFinalDiscountRate = Boolean(useFinalDiscountRate)
  },
  toggleUseFinalDiscountRate (state) {
    state.createView.useFinalDiscountRate = !state.createView.useFinalDiscountRate
  },
  setCreateDamageInsuranceSelection (state, selection) {
    if (!selection || selection.pclid == null) return
    state.createView.damageInsuranceSelections = {
      ...state.createView.damageInsuranceSelections,
      [String(selection.pclid)]: { ...selection },
    }
  },
  removeCreateDamageInsuranceSelection (state, pclid) {
    const selections = { ...state.createView.damageInsuranceSelections }
    delete selections[String(pclid)]
    state.createView.damageInsuranceSelections = selections
  },
  setCreateDamageInsuranceBrief (state, brief) {
    state.createView.damageInsuranceBrief = normalizeDamageInsuranceBrief(brief)
    if (state.createView.damageInsuranceBrief) {
      state.createView.confirmationErrors.damageInsuranceBrief = false
    }
  },
  setCreateDamageInsuranceError (state, message) {
    state.createView.damageInsuranceError = message || ''
  },
  setCreateConfirmation (state, { key, value }) {
    assertConfirmationKey(state, key, 'confirmations')
    state.createView.confirmations[key] = Boolean(value)
  },
  setCreateConfirmationError (state, { key, value }) {
    assertConfirmationKey(state, key, 'confirmationErrors')
    state.createView.confirmationErrors[key] = Boolean(value)
  },
}

export const actions = {
  setDeliveryMode ({ commit }, value) {
    commit('setDeliveryMode', value)
  },
  resetUnavailableCvsDelivery ({ commit }) {
    commit('resetUnavailableCvsDelivery')
  },
  setPendingTransport ({ commit }, value) {
    commit('setPendingTransport', value)
  },
  setEstimateWeight ({ commit }, value) {
    commit('setEstimateWeight', value)
  },
  setUseFinalDiscountRate ({ commit }, value) {
    commit('setUseFinalDiscountRate', value)
  },
  toggleUseFinalDiscountRate ({ commit }) {
    commit('toggleUseFinalDiscountRate')
  },
  setCreateConfirmation ({ commit }, payload) {
    commit('setCreateConfirmation', payload)
  },
  setCreateConfirmationError ({ commit }, payload) {
    commit('setCreateConfirmationError', payload)
  },
}

export { CONFIRMATION_KEYS }
